export const login = (password) => {
  const PASSWORD = 'Micoope1969*';

  if (password === PASSWORD) {
    const expiration = new Date().getTime() + (120 * 60 * 1000); // 2 horas

    localStorage.setItem('auth', 'true');
    localStorage.setItem('auth_exp', expiration);

    return true;
  }
  return false;
};

export const isAuthenticated = () => {
  const auth = localStorage.getItem('auth');
  const exp = localStorage.getItem('auth_exp');

  if (!auth || !exp) return false;

  if (new Date().getTime() > parseInt(exp)) {
    logout();
    return false;
  }

  return true;
};

export const logout = () => {
  localStorage.removeItem('auth');
  localStorage.removeItem('auth_exp');
};